<template>
  <div id="home">
    <div class="top-nav-box">
      <div class="top-nav">
        <img src="../assets/img/benq_logo.png" alt="">
        <div class="link-list">
          <div class="dropdown">
            <p>明基设计大赛</p>
            <div class="dropdown-menu">
              <a href="#">第五届明基设计大赛</a>
              <a href="https://designvue.benq.com.cn/2023/contestDetail" target="_blank">第四届明基设计大赛</a>
              <a href="https://designvue.benq.com.cn/2021/contestDetail" target="_blank">第三届明基设计大赛</a>
              <a href="https://mp.weixin.qq.com/s/PPf2sq7V9WPTPwpGY1NtfA" target="_blank">第二届明基设计大赛</a>
              <a href="https://mp.weixin.qq.com/s/RSlXGFWAmQ9CMeoguv7jcw" target="_blank">第一届明基设计大赛</a>
            </div>
          </div>
          <!-- <a href="https://designvue.benq.com.cn/2021/show">2022“风潮由我”CG数字艺术展</a>
          <a href="https://3.cn/109W-0uSn">明基PD系列专业设计显示器</a> -->
        </div>
        <div v-if="!$store.state.hasLogin" class="btn-list">
          <div @click="login">注册</div>
          <div @click="login">登录</div>
        </div>
        <div v-else class="btn-list profile-btn">
          <div class="headimg" @click="goProfile" :style="{ 'background-image': `url(${profileinfo.headImg})` }"></div>
          <div class="username" @click="goProfile">{{ profileinfo.userName }}</div>
          <div class="logout" @click="logOut">退出登录</div>
        </div>
      </div>
    </div>
    <div class="banner-box" v-if="$router.currentRoute.value.href !== '/show'">
      <img class="banner-img" src="../assets/img/banner.png" alt="">
      <div class="sign-btn" @click="goReward">
        <img src="@/assets/img/signbtn.png" alt="">
      </div>
    </div>
    <div class="nav-menu-box" v-if="$router.currentRoute.value.href !== '/show'">
      <ul class="nav-menu-List">
        <router-link :to="item.path" v-text="item.meta.title" class="menu-item"
          :class="{ 'router-link-active': item.path == menuPath }" v-for="(item, index) in navMenu"
          :key="index"></router-link>
      </ul>
    </div>
    <div class="container-box">
      <div class="conatiner">
        <router-view />
      </div>
    </div>
    <div class='footer-box'>
      <div class="orgLink">
        <div class="link-wrap">
          <div class="link-item" v-for="(item, index) in logoList.list" :key="index">
            <div class="link-item-name">{{ item.title }}</div>
            <div class="link">
              <a v-for="(item1, index1) in item.data" :key="index1" @click.stop="goLink(item1)">
                <img :src="item1.logoSrc" alt="" :style="{ height: item1.height }" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <beian />
    </div>
  </div>
</template>

<script>
import Beian from '../components/beian.vue'
import { brandHit } from "../utils/apis/brandApi";
import { reactive, watch, ref, onMounted,computed } from "vue";
import menuList from "../router/menuList";
import { useRoute, useRouter } from "vue-router";
import { useStore } from 'vuex'
import { getPersonal } from '../utils/apis/userApi'
import { verify } from '../utils/apis/userLoginApi';
import {markPageView,increasePageView} from "../utils/apis/worksApi";

export default {
  name: "Home",
  components: { Beian },
  setup() {
    const logoList = reactive({
      list: [
        {
          title: "主 办 方",
          data: [
            {
              name: "明基",
              logoSrc: require("../assets/img/infoPic/BenQ.png"),
              href: "https://pro.m.jd.com/mall/active/qAJnTqVPM7BmoMjTJyUjY46EoWd/index.html?jd_pop=8bd84f74-6a3a-46e3-9520-935e8af75583&ad_od=1&mtm_source=kepler-open&mtm_subsource=d391e66cee144a13819a5421cd834e6f&utm_source=kong&utm_medium=zssc&utm_campaign=t_1001006693_19259_78106_null&utm_term=8bd84f74-6a3a-46e3-9520-935e8af75583-p_0-at_19259_78106_null&extension_id=eyJhZCI6IiIsImNoIjoiOCIsInNob3AiOiIxMDAwMDAwNDM3Iiwic2t1IjoiIiwidHMiOiIxNzQ1ODk4MTY4In0=",
              height: "23px",
            },
          ],
        },
        {
          title: "指导单位",
          data: [
            {
              name: "中国电影美术学会CG艺术专业委员会",
              logoSrc: require("../assets/img/infoPic/CFCA.png"),
              href: "http://www.fashioncolor.org.cn/",
              height: "35px",
            }
          ]
        },
        {
          title: "协 办 方",
          data: [
            {
              name: "CG模型网",
              logoSrc: require("../assets/img/infoPic/moxing.png"),
              href: "https://www.cgmodel.com/",
              height: "36px",
            },
            {
              name: "GGAC",
              logoSrc: require("../assets/img/infoPic/GGAC.png"),
              href: "https://www.ggac.com/home",
              height: "40px",
            },
            {
              name: "涂鸦王国",
              logoSrc: require("../assets/img/infoPic/tuya.png"),
              href: "https://www.gracg.com/home",
              height: "22px",
            },
            {
              name: "普象网",
              logoSrc: require("../assets/img/infoPic/puxiang.png"),
              href: "https://www.puxiang.com/",
              height: "27px",
            },
            {
              name: "Mana",
              logoSrc: require("../assets/img/infoPic/MANA.png"),
              href: "https://www.manamana.net/",
              height: "54px",
            },
          ],
        },
        {
          title: "联合品牌",
          data: [
            {
              name: "七彩虹",
              logoSrc: require("../assets/img/infoPic/COLORFUL.png"),
              href: "https://www.colorful.cn/",
              height: "28px",
            },
            {
              name: "Tourbox",
              logoSrc: require("../assets/img/infoPic/TOURBOX.png"),
              href: "https://www.tourboxtech.cn/digital-painting/",
              height: "38px",
            },
            {
              name: "Pantone",
              logoSrc: require("../assets/img/infoPic/PANTONE.png"),
              href: "https://www.pantonecn.com/",
              height: "19px",
            }
          ],
        },
        {
          title: "行业支持",
          data: [
            {
              name: "优设",
              logoSrc: require("../assets/img/infoPic/youshe.png"),
              href: "https://www.uisdc.com/",
              height: "33px",
            },
            {
              name: "字体帮",
              logoSrc: require("../assets/img/infoPic/ziti.png"),
              href: "https://www.zitisheji.com",
              height: "35px",
            },
            {
              name: "YOCG",
              logoSrc: require("../assets/img/infoPic/YOCG.png"),
              href: "https://www.xiaohongshu.com/user/profile/60af5db20000000001000f40",
              height: "32px",
            },
            {
              name: "杰视帮",
              logoSrc: require("../assets/img/infoPic/JSB.png"),
              href: "https://vip.jsboom.com/",
              height: "22px",
            },
            {
              name: "创赛云",
              logoSrc: require("../assets/img/infoPic/chuangsai.png"),
              href: "https://www.newunivs.com",
              height: "58px",
            },
            {
              name: "欧阳鹏杰设计",
              logoSrc: require("../assets/img/infoPic/OYART.png"),
              href: "https://mp.weixin.qq.com/s/zgJYXhzGQWvgbTzRSaRnvw",
              height: "56px",
            },
            {
              name: "创意齿轮",
              logoSrc: require("../assets/img/infoPic/chuangyi.png"),
              href: "https://weibo.com/u/6600192993",
              height: "26px",
            },
          ],
        },
        {
          title: "软件支持",
          data: [
            {
              name: "Marvelous Designer",
              logoSrc: require("../assets/img/infoPic/MARVELOUS.png"),
              href: "https://landing.marvelousdesigner.com/",
              height: "32px",
            },
          ],
        },
        {
          title: "在线设计阵地",
          data: [
            {
              name: "Canva可画",
              logoSrc: require("../assets/img/infoPic/CANVA.png"),
              href: "https://www.canva.cn/",
              height: "23px",
            },
          ],
        },
        {
          title: "渲染支持",
          data: [
            {
              name: "炫云",
              logoSrc: require("../assets/img/infoPic/xuanyun.png"),
              href: "https://cloud.shinewonder.com/",
              height: "34px",
            },
          ],
        },
        {
          title: "字体支持",
          data: [
            {
              name: "造字工房",
              logoSrc: require("../assets/img/infoPic/zaozi.png"),
              href: "https://www.makefont.com/",
              height: "42px",
            },
          ],
        },
        {
          title: "出版支持",
          data: [
            {
              name: "人民邮电出版社",
              logoSrc: require("../assets/img/infoPic/youdian.png"),
              href: "https://www.shuyishe.com/",
              height: "24px",
            },
          ],
        },
        {
          title: "高校支持",
          data: [
            {
              name: "高校支持",
              logoSrc: require("../assets/img/infoPic/college.png"),
              href: "#",
              height: "118px",
            },
          ],
        },
      ],
    });

    function goLink(item) {
      console.log(item);
      brandHit({ brand: item.name }).then((res) => {
        if (res.data.code === 200) {
          window.location.href = item.href;
        }
      });
    }
    function goUpload() {
      router.push('/uploadFile')
      document.documentElement.scrollTop = 820;
    }
    const store = useStore();
    const navMenu = reactive(menuList);
    const route = useRoute();
    const router = useRouter();
    const menuPath = ref(route.meta.menuPath);
    const profileinfo = reactive({
      userName: '',
      headImg: '',
    })
    markPageView().then(res => {
      if (res.data.code === 200) {
        setTimeout(() => {
          increasePageView({
            code: res.data.data
          }).then(() => {

          })
        }, 5000)
      }
    })
    if (localStorage.userInfo && localStorage.token) {
      verifyToken()
    }
    // watch 监听
    watch(
      () => route.meta,
      (val, oldval) => {
        console.log(oldval, val);
        menuPath.value = val.menuPath;
      }
    );
    function getPersonlinfo() {
      getPersonal().then(res => {
        if (res.data.code === 200) {
          profileinfo.headImg = res.data.data.headImg
          profileinfo.userName = res.data.data.userName
        }
      })
    }
    function verifyToken() {
      verify().then(res => {
        console.log(res)
        if (res.data.code === 200) {
          getPersonlinfo()
        } else {
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
        }
      })
    }
    function goReward() {
      router.push('/uploadFile')
      window.scrollTo({
        top: 1000,
        left: 0,
        behavior: 'smooth'
      })
    }
    function handleLogoClick() {
      window.open("https://pro.m.jd.com/mall/active/qAJnTqVPM7BmoMjTJyUjY46EoWd/index.html?jd_pop=8bd84f74-6a3a-46e3-9520-935e8af75583&ad_od=1&mtm_source=kepler-open&mtm_subsource=d391e66cee144a13819a5421cd834e6f&utm_source=kong&utm_medium=zssc&utm_campaign=t_1001006693_19259_78106_null&utm_term=8bd84f74-6a3a-46e3-9520-935e8af75583-p_0-at_19259_78106_null&extension_id=eyJhZCI6IiIsImNoIjoiOCIsInNob3AiOiIxMDAwMDAwNDM3Iiwic2t1IjoiIiwidHMiOiIxNzQ1ODk4MTY4In0=")
    }
    return {
      navMenu,
      menuPath,
      profileinfo,
      logoList,
      goLink,
      goUpload,
      goReward,
      handleLogoClick,
    };
  },
  methods: {
    rewardClick() {
    },
    login() {
      this.$router.push('/signUp')
      document.documentElement.scrollTop = 820;
    },
    goProfile() {
      this.$router.push('/myWorks')
      document.documentElement.scrollTop = 820;
    },
    logOut() {
      localStorage.removeItem('token')
      location.reload()
    },
  },
  mounted() {
   const dpr = window.devicePixelRatio; 
  }

};

</script>

<style lang="less">
#home {
  background-color: #DBE5D6;
  overflow: hidden;

  // .uploadLink {
  //   position: absolute;
  //   left: 18.5%;
  //   bottom: 23%;
  //   width: 13vw;
  //   height: 4vw;
  //   min-width: 225px;
  //   min-height: 65px;
  //   font-weight: bold;
  //   opacity: 0;
  // }

  min-width: 1200px;
  min-height: 800px;

  .home-title-box {
    height: 60px;
    background-color: #000;

    .home-title-logo {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;

      img {
        height: 25px;
      }
    }
  }

  .top-nav-box {
    height: 68px;
    background-color: #282828;

    .top-nav {
      max-width: 1920px;
      min-width: 1200px;
      padding: 0 50px 0 50px;
      box-sizing: border-box;
      height: 60px;
      margin: 0 auto;
      position: relative;
      z-index: 99;

      &>img {
        width: 166px;
        height: 19px;
        cursor: pointer;
        position: absolute;
        left: 50px;
        top: 50%;
        transform: translateY(-50%);
      }

      .link-list {
        width: 764px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        justify-content: space-between;

        .dropdown {
          position: relative;
          display: inline-block;
          cursor: pointer;
          height: 68px;
          line-height: 68px;

          p {
            color: #ffffff;
            font-size: 14px;
            font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          }

          .dropdown-menu {
            display: none;
            position: absolute;
            line-height: normal;
            top: 50px;
            background-color: #f9f9f9;
            min-width: 160px;
            box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
            border-radius: 4px;

            a {
              color: black;
              padding: 12px 16px;
              text-decoration: none;
              display: block;
              font-size: 14px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;

              &:hover {
                background-color: #f1f1f1;
              }
            }

          }

          &:hover .dropdown-menu {
            display: block;
          }
        }

        &>a {
          width: 224px;
          height: 30px;
          border-radius: 6px;
          text-decoration: none;
          font-size: 14px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: center;
          color: #ffffff;
          line-height: 30px;
          cursor: pointer;
        }
      }

      .btn-list {
        margin-top: 16px;
        height: 30px;
        float: right;
        display: flex;
        justify-content: space-around;

        &>div {
          margin-right: 20px;
          height: 40px;
          border-radius: 40px;
          font-size: 14px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: center;
          color: #ffffff;

          line-height: 40px;
          cursor: pointer;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }

      }

      .profile-btn {
        width: auto;

        .headimg {
          margin: 0;
          width: 40px;
        }

        .username {
          margin-left: 10px;
          margin-right: 20px;
          text-overflow: ellipsis;
          word-wrap: break-word;
          white-space: nowrap;
        }
      }
    }

  }

  .banner-box {
    // width: 1920px;
    // height: 933px;
    margin: 0 auto;
    // background: url("../assets/img/banner.png") repeat;
    // background-size: contain;
    // background-position: center;
    position: relative;

    .banner-img {
      width: 100%;
    }

    .sign-btn {
      position: absolute;
      left: 8.59%;
      top: 57.74%;
      width: 11.7%;
      height: 9.2%;
      cursor: pointer;

      &>img {
        width: 100%;
      }
    }

    //     >img {
    //       width: 1920px;
    // height: 933px;
    //       position: absolute;
    //       left: 19%;
    //       bottom: 21%;
    //     }

    // min-height: 820px;
  }

  .nav-menu-box {
    height: 94px;
    background-color: #6C835D;

    .nav-menu-List {
      width: 1400px;
      margin: 0 auto;
      height: 94px;
      line-height: 94px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .menu-item {
        height: 94px;
        max-width: 280px;
        font-size: 30px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        color: #D9E0D5;
        line-height: 94px;
        letter-spacing: 0.6px;
        flex: 1;
        text-align: center;
        cursor: pointer;
        text-decoration: none;
      }

      .router-link-active {
        background: #344F23;
        color: #EBEDEA;
      }

      .menu-item:hover {
        background: #344F23;
        color: #EBEDEA;
      }
    }
  }

  // .container-box {
  //   padding-top: 70px;
  // }
  .conatiner {
    // min-height:400px;
    // width: 1200px;
    box-sizing: border-box;

    // background-image: ;
    // margin: 0 auto;
  }

  .footer-box {
    // height: 330px;
    box-sizing: border-box;

    .orgLink {
      background-color: #272727;
      padding-top: 60px;
      padding-bottom: 55px;

      :nth-child(5) {
        .link-item-name {
          transform: translateY(6px);
        }
      }

      .link-wrap {
        width: 1126px;
        height: 797px;
        margin: 0 auto;

        .link-item {
          overflow: hidden;
          margin: 0 auto;
          margin-bottom: 15px;

          .link-item-name {
            float: left;
            line-height: 45px;
            width: 115px;
            font-family: "FZLTHJW";
            font-size: 19px;
            color: #B6B6B6;
            text-align-last: left;
            text-align: left;
          }

          .link {
            margin-left: 132px;
            line-height: 45px;
            font-size: 0px;

            a {
              display: inline-block;
              line-height: 45px;
              margin-right: 62px;
              cursor: pointer;

              img {
                vertical-align: middle;
              }
            }
          }

          .link :last-child {
            margin: 0;
          }
        }
      }
    }

    .beian {
      // height: 174px;
      // line-height: 174px;
      text-align: center;
      color: #7e3e34;
      padding-top: 20px;

      .beian-box {
        padding: 12px 0 13px;
        text-align: center;

        div {
          display: inline-block;
          font-size: 12px;
          color: rgb(152, 152, 152);

          a {
            text-decoration: none;
            color: rgb(152, 152, 152);
          }

          img {
            height: 12px;
            width: 12px;
            vertical-align: middle;
            // margin-top: 3px;
            margin-right: 6px;
          }
        }

        .line {
          vertical-align: middle;
          background: rgb(152, 152, 152);
          height: 12px;
          font-size: 12px;
          margin: 0 10px;
          width: 1px;
        }
      }
    }
  }
}
</style>
